import { useQuery } from 'react-query';

import { getSubProgramPreferenceInfo as queryFn } from 'api/endPoints/getSubProgramPreferenceInfo';

export const useQueryGetSubProgramPreferenceInfo = () => {
    return useQuery({
        queryKey: ['useQueryGetSubProgramPreferenceInfo'],
        queryFn: () => queryFn(),
    });
};
